import styled, { keyframes } from "styled-components";

const move = keyframes`
  20%{
    transform: translateX(0);
  }
  100%{
    transform: translateX(202px);
  }
`;

export const AnimText = styled.span`
  position: absolute;
  animation: ${move};
  animation-iteration-count: infinite;
  animation-duration: 50s;
  animation-timing-function: ease-in-out;
`;

export const activeRowStyle = (isPlaying, themed) => {
  let theme = !themed ? {
    color: 'rgb(249 78 63)',
    backgroundColor: 'rgb(252 239 239)'
  } : {
    color: isPlaying ? '#f94e3f' : 'inherit',
    backgroundColor: isPlaying ? '#0f0e37' : 'inherit'
  }

  theme = { ...theme, transition: 'background-color 0.5s, color 0.5s' }

  return theme;
}

export const Div = styled.div`
  padding: 3em 0;

  @media (min-width: 789px) {
    padding: 3em 5%;

    .image {
      display: block;
      position: absolute;
      top: 10%;
      left: 10%;
    }
  }

  @media (min-width: 1100px) {
    max-width: 90%;
    margin: auto;
  }
`;
export const Wrapper = styled.div`
  position: relative;

  .playBtn {
    visibility: hidden;
  }

  .tableRow {
    position: relative;
  }

  .tableRow:hover .playBtn {
   visibility: visible;
  } 

  .tableRow:hover{
    color: #f94e3f
  }

  .tableRow td{
    min-width: 10em;
  }
`;

export const Container = styled.div`
  overflow-x: auto;
  display: flex;
  min-height: 316px;
  /* max-height: 416px; */
  padding: 1em;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Card = styled.div`
  min-width: 284px;
  height: 284px;
  margin-right: 1em;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    border-radius: 15px;
  }

  &:hover .overlay {
    opacity: 1;
    pointer-events: visible;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  background: linear-gradient(
    to top,
    rgba(249, 72, 63, 0.7),
    rgba(128, 60, 40, 0.4)
  );
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease-in-out;

  .play-btn {
    color: white;
    cursor: pointer;
  }

  .media-controls {
    button {
      border-radius: 0.5em;
      padding: 0.5em 1em;
      background: orangered;
      color: white;
      border: none;
      outline: none;
    }
  }
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 10vh;
  padding: 1em;
`;
export const Icons = styled.h1`
  margin: 0;
`;
export const H1 = styled.h1`
  margin: 0;
`;
